import { render, staticRenderFns } from "./detailInformation.vue?vue&type=template&id=ecde7784&scoped=true"
import script from "./detailInformation.vue?vue&type=script&lang=js"
export * from "./detailInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde7784",
  null
  
)

export default component.exports